import { useMemo } from "react";
import { Link } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";

const CatalogBreadcrumb = ({
    items = [],
    homeLabel = "Inicio",
    homeTo = "/catalogo",
    className = "",
}) => {
    const model = useMemo(
        () => items.map((item) => ({
            label: item.label,
            template: () => (
                
                    <Link to={item.to} className="catalog-breadcrumb-link">
                        {item.label}
                    </Link>
                
            ),
        })),
        [items]
    );

    const home = useMemo(
        () => ({
            template: () => (
                <Link to={homeTo} className="catalog-breadcrumb-link">
                    {homeLabel}
                </Link>
            ),
        }),
        [homeLabel, homeTo]
    );

    return <BreadCrumb model={model} home={home} className={className} />;
};

export default CatalogBreadcrumb;
